export const shrinkWrappedText = (el) => {
    if (el?.innerText) {
        const content = el.innerText;
        const textNode = Array.from(el.childNodes).find(({ textContent }) => {
            return textContent.replace(/\s/g, '') === content.replace(/\s/g, '');
        });
        if (textNode) {
            const range = document.createRange();
            range.setStartBefore(textNode);
            range.setEndAfter(textNode);
            const clientRect = range.getBoundingClientRect();
            el.style.width = `${clientRect.width}px`;
        }
    }
    return el;
};
//# sourceMappingURL=shrink-wrapped-text.directive.js.map